import React, { useState } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { fmtDateTime } from '../../../lib/when';
import { HISTORY_FILTERS, filterEvents, historyCounts, eventSentence } from '../assetView';

/**
 * HISTORY: every line ever written about the device, newest first - who did
 * what, on whose behalf, from what to what - with chips to see one kind at
 * a time. The wording is eventSentence's, as it always was.
 */
export default function HistoryTab() {
  const { data } = useOutletContext();
  const [filter, setFilter] = useState('all');
  const events = data.events || [];
  const counts = historyCounts(events);
  const shown = filterEvents(events, filter);
  return (
    <div className="as-tab as-tab-history">
      <div className="as-filters" role="group" aria-label="Show only">
        {HISTORY_FILTERS.map((f) => (
          <button key={f.key} type="button" className={`as-filter${filter === f.key ? ' is-active' : ''}`}
            aria-pressed={filter === f.key} data-filter={f.key} onClick={() => setFilter(f.key)}>
            {f.label}
            <span className="as-filter-count">{counts[f.key]}</span>
          </button>
        ))}
      </div>
      <section className="as-panel">
        {events.length === 0 && <p className="as-empty">Nothing has happened to this device yet.</p>}
        {events.length > 0 && shown.length === 0 && (
          <p className="as-empty">{`No ${HISTORY_FILTERS.find((f) => f.key === filter)?.label.toLowerCase()} yet.`}</p>
        )}
        {shown.length > 0 && (
          <ul className="as-history as-timeline">
            {shown.map((e) => (
              <li key={e.id} data-kind={e.kind}>
                {e.ticket_id && e.kind.startsWith('ticket_')
                  ? <Link to={`/tickets/${e.ticket_id}`}>{eventSentence(e)}</Link>
                  : eventSentence(e)}
                {e.reason && e.kind !== 'discovered' && <>{e.kind === 'noted' || e.kind === 'repaired' ? ': ' : ' — '}{e.reason}</>}
                <span className="as-when">
                  {`${e.actor_name}${e.on_behalf_by ? ` (by ${e.on_behalf_by} on their behalf)` : ''}`}
                  {` · ${fmtDateTime(e.created_at)}`}
                </span>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
